/** 键名沿用原型挂件，已经在店面留下 uid 的买家不会掉会话。 */
export const UID_STORAGE_KEY = "gonovus_ai_uid";
const PLAYGROUND_UID_PREFIX = "test:";
const SHOPPER_UID_PATTERN = /^gnv_[A-Za-z0-9_-]{32,}$/;
const UID_BYTE_LENGTH = 24;

/** Playground 会话的 uid，不进 Inbox、不计指标、不落 localStorage。 */
export function isPlaygroundUid(uid: string): boolean {
  return uid.startsWith(PLAYGROUND_UID_PREFIX);
}

/** 24 字节随机数的 base64url 形式，带 `gnv_` 前缀。 */
export function createUid(): string {
  const bytes = new Uint8Array(UID_BYTE_LENGTH);
  crypto.getRandomValues(bytes);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return `gnv_${btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "")}`;
}

/**
 * 店面挂件的买家身份：读 localStorage，没有或不合格式就重新生成并写回。
 * `test:` 前缀的 Playground uid 不满足格式，读到也会被换掉，因此永远不会留在 localStorage 里。
 */
export function getOrCreateUid(storage: Storage = localStorage): string {
  const existing = readStoredUid(storage);
  if (existing) return existing;
  const uid = createUid();
  storage.setItem(UID_STORAGE_KEY, uid);
  return uid;
}

/** 恢复已有会话只读身份，不创建或写入新 uid。 */
export function readStoredUid(
  storage: Storage = localStorage,
): string | undefined {
  const existing = storage.getItem(UID_STORAGE_KEY);
  if (existing !== null && SHOPPER_UID_PATTERN.test(existing)) {
    return existing;
  }
  return undefined;
}
